import { Injectable, Inject, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SharedService {

  constructor() { }

  public sharedEmitter = new EventEmitter<any>();
}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts